import Vue from 'vue';
import store from '@/store';
import { AICHAT_ATTR, HELP_ARTICLE_CLICKED_EVENT } from '../constants/helpConstants';
import { resolveHelpDestination, buildHelpLaunch, articleCodeFromHref } from '../utils/helpRules';

// See ../README.md for the two destinations, the data-aichat contract, and the helpers for
// help links passed as props into Design System components.

export function helpDestination() {
  return resolveHelpDestination(store.getters);
}

export function openHelp(options) {
  store.dispatch('AiChatStore/launchWorkflow', buildHelpLaunch(options));
}

export function routeHelpLinkClick(event, { message, source } = {}) {
  const destination = helpDestination();
  if (destination === 'external') return destination;
  event?.preventDefault?.();
  openHelp({ message, source });
  return destination;
}

export function routeHelpAnchorClick(event, options) {
  if (!event?.target?.closest?.('a.VcLink')) return null;
  return routeHelpLinkClick(event, options);
}

export function handleHelpLinkClick(event) {
  const anchor = event?.target?.closest?.(`a[${AICHAT_ATTR}]`);
  if (!anchor) return;
  const destination = helpDestination();
  Vue.prototype.$track(HELP_ARTICLE_CLICKED_EVENT, {
    'Article Code': articleCodeFromHref(anchor.getAttribute('href')),
    destination,
  });
  if (destination === 'external') return;
  event.preventDefault();
  event.stopPropagation();
  openHelp({ message: anchor.getAttribute(AICHAT_ATTR), source: 'help_article' });
}

export function installHelpLinkCatcher(doc = document) {
  doc.addEventListener('click', handleHelpLinkClick, true);
}
